export default {
    common: {
        language: 'English',
        switchLanguage: 'Switch Language',
        documentationCenter: 'Document Center',
        console: 'console',
        signIn: 'signIn',
        register: 'register',
        Cart: 'Cart',
        userInformation: 'User Information',
        unpaidOrders: 'Unpaid orders',
        myTicket: 'myTicket',
        exitAccount: 'exitAccount',
        selected: 'Selected',
    },

    index: {
        bannerButton: 'View details',
        shop1: 'Stable and efficient, safeguarding your cloud security',
        shop2: 'Ensure enterprise data and applications can be seamlessly migrated to the cloud.',
        viewAll: 'viewAll',
        buyNow: 'buyNow',
        noDataAvailable: 'No data available',
        month: 'month',
        nucleus: 'nucleus',
        memory: 'memory',
        systemDisk: 'system disk',
        dataDisk: 'data disk',
        bandwidth: 'bandwidth',
        defense: 'defense',
        shopNow: 'shopNow',
        goImmediately: 'Go immediately',
        viewAllProducts: 'View all products',
        shop3: 'cloud computing',
        shop4: 'The choice for safety, reliability, and high performance',
        shop5: 'In the new era of cloud computing,',
        shop6: 'Provide enterprises with secure, efficient, and flexible cloud services.',
        cloudMarket: 'A one-stop cloud marketplace that empowers enterprise business development',
        cloudMarket2: 'Meet diverse demand services and build a whole-process ecosystem that empowers customers',
        cloudMarket3: `Baidu AI Cloud collaborates with top partners across a wide range of industries to help businesses migrate to the cloud and meet their diverse needs. Together, we deliver scenario-based solutions and quality services, fostering a vibrant ecosystem that drives industrial transformation.`,
        cloudMarket4: 'An excellent partner, offering products across all industries and categories, meets the cloud migration and application needs of various business types. build',
        cloudMarket5: 'Scenario plan and output',
        cloudMarket6: 'High-quality product services, services',
        cloudMarket7: `Customers, collaborate with partners to build an ecosystem on the cloud, and facilitate the transformation of customers' industries.`,

        cloudMarket8: 'Quality service provider',
        cloudMarket9: 'Official shelf life',
        cloudMarket10: 'Customer Service',
        cloudMarket11: 'No worries about refunds',

        cloudMarket12: 'trademark registration',
        cloudMarket13: 'server operation and maintenance',
        cloudMarket14: 'data processing',
        cloudMarket15: 'Enterprise official website construction',
        cloudMarket16: 'Enterprise qualification processing',
        cloudMarket17: '400 Telephone processing',

        solution1: 'Industry Solutions',
        solution2: 'Provide comprehensive digital transformation services for your enterprise',
        solution3: 'Website Solution',
        solution3_3: 'Website Solution',
        solution4: 'Game Cloud Solution',
        solution5: 'Mobile Cloud Solution',
        solution6: 'Financial Cloud Solution',
        solution7: 'E-commerce Cloud Solution',

        solution8: 'Enterprise level website construction solution',
        solution9: 'We provide a one-stop solution for enterprise website construction, including responsive design, SEO optimization, high-performance architecture, security protection, CMS backend management, and e-commerce integration. We use cutting-edge technology to create a fast, secure, and easy-to-use modern website, helping enterprises enhance their brand image, optimize user experience, and achieve business growth. At the same time, we provide continuous technical support and data analysis services to ensure that your website maintains a leading edge in the fiercely competitive market. ​',
        solution10: 'customer satisfaction',
        solution11: 'After sales efficiency',
        solution12: 'data accuracy',
        solution10_1: 'excellent',
        solution11_2: 'efficient',
        solution12_3: 'reliable',

        solution13: 'We provide professional gaming industry solutions, including game website development, H5 mini game customization, game community building, payment system integration, data analysis platform, and global CDN acceleration, using Unity',
        solution14: `We provide high-performance, high security, and high experience mobile full lifecycle solutions, covering native app development (iOS/Android) and cross platform applications (Flutter/React)
Native）、 Applet (WeChat/Alipay/Tiktok), PWA progressive web application and other technical forms, and the integration of AI intelligent recommendation, AR augmented reality, IoT Internet of Things access and other innovative technologies, create an extremely smooth, safe and reliable mobile product experience for enterprises.​​`,
        solution15: `We provide safe, compliant, high-performance, intelligent financial technology full stack solutions, and deeply enable digital transformation of banks, securities, insurance, Internet finance and other institutions. Based on cloud computing, big data, artificial intelligence, and blockchain technology, we will build a complete product matrix covering six core areas: digital banking, payment clearing, intelligent risk control, wealth management, insurance technology, and regulatory technology, providing financial institutions with comprehensive support from technological infrastructure to business innovation.`,
        solution16: `We provide omnichannel, intelligent, and high conversion digital solutions for the entire e-commerce chain, deeply integrating platform e-commerce, social e-commerce, live streaming e-commerce, cross-border e-commerce, and new retail to build a complete business ecosystem from front-end marketing to back-end supply chain. Based on big data and AI technology, we aim to create a new generation of e-commerce infrastructure that integrates intelligent operations, precision marketing, efficient fulfillment, and data-driven approaches, helping enterprises achieve traffic growth, conversion enhancement, and maximize commercial value. ​​`,

        choice1: 'Why choose us',
        choice2: 'Professional service team, rich industry experience, to provide you with the best quality service',
        choice3: 'safe and reliable',
        choice4: 'Multiple security protection mechanisms ensure data security',
        choice5: 'quick response',
        choice6: '24/7 technical support to quickly solve problems',
        choice7: 'excellent performance',
        choice8: 'Adopting advanced technology architecture to ensure efficient operation',
        choice9: 'Professional Services',
        choice10: 'Experienced technical team providing professional support',

        choice11: 'Why choose us',
        choice12: 'Committed to providing you with excellent and reliable one-stop solutions and services',
        choice13: 'Comprehensive security guarantee',
        choice14: 'Adopting an industry-leading multi-level protection system, strictly following security standards, ensuring full process security protection for business data, privacy information, and application systems, and providing a stable and reliable security environment for enterprises',
        choice15: 'data encryption',
        choice16: 'access control',
        choice17: 'real-time monitoring',
        choice18: 'Fast response support',
        choice19: 'Provide 24/7 uninterrupted technical service support, with a team of senior experts on standby at any time to quickly respond to various technical issues and emergency needs, ensuring the continuous and stable operation of business without interruption',
        choice20: '7x24 online',
        choice21: 'Minute response',
        choice22: 'professional team',
        choice23: 'Excellent performance',
        choice24: 'Based on advanced distributed technology architecture and optimization algorithms, provide a high-performance and highly available operating environment to ensure system processing efficiency and response speed, and meet the requirements of high concurrency business scenarios',
        choice25: 'high concurrency',
        choice26: 'low latency',
        choice27: 'high availability',
        choice28: 'Professional technical services',
        choice29: 'A team of technical experts with rich industry experience provides one-stop professional services from consulting planning, implementation deployment to operation and maintenance optimization, ensuring that customers receive the best technical solutions and sustained value',
        choice30: 'Solution Consulting',
        choice31: 'Implement deployment',
        choice32: 'Operations Support',

        cooperativePartner1: 'partner',
        cooperativePartner2: 'Establish long-term and stable cooperative relationships with industry-leading enterprises',
        cooperativePartner3: 'Building a Cloud Ecological Future Together',
        cooperativePartner4: 'Assist enterprises in efficiently going to the cloud and work together to explore new digital frontiers',

        build1: 'Infrastructure construction',
        build2: 'Global infrastructure nodes provide users with fast, stable, intelligent, and reliable services',
        build3: 'Global infrastructure',
        build4: 'Layout in multiple geographical regions around the world, providing high-speed and stable cloud connectivity networks',
        build5: 'Learn more',
        build6: 'Countries and regions',
        build7: 'region',
        build8: 'CDN node',
        build9: 'Availability Zone',

        new1: 'News Updates',
        new2: 'View more news',
        new3: 'Release Date',
        new4: 'news',
        new5: 'Announcement',

        footer1: 'calculate',
        footer2: 'Company Introduction',
        footer3: 'qualification',
        footer4: 'Industry Solutions',
        footer5: 'Help and Support',
        footer6: 'Account issues',
        footer7: 'Filing Guidelines',
        footer8: 'Frequently Asked Questions',
        footer9: 'Website registration',
        footer10: 'Ticket Service',
        footer11: 'Collaboration and Ecology',
        footer12: 'Collaboration and Ecology',
        footer13: 'CPS promotion',
        footer14: 'Official Announcement',
        footer15: 'Contact Us',
        footer16: 'Product Center',
        footer17: 'Management Center',
        footer18: 'Control Center',
        footer19: 'Security Center',
        footer20: 'Resource Center',
        footer21: 'Financial Management',
        footer22: 'Account Management',
        footer23: 'Friendship links',
        footer24: 'Customer Service Hotline',

        footer25: '24/7 after-sales service',
        footer26: '7x24 hour professional engineer quality service',
        footer27: 'Fast service response',
        footer28: 'Instant response to safeguard business operations',
        footer29: 'Customer value first',
        footer30: 'From service value to creating customer value',
        footer31: 'Comprehensive security guarantee',
        footer32: 'Creating a Transparent and Trustworthy Cloud',

        footer33: 'Official Service Hotline',

        loading: 'Loading page',

        loading1: 'L',
        loading2: 'o',
        loading3: 'a',
        loading4: 'din',
        loading5: 'g',

        HzQuickjump1: 'Product advantages',
        HzQuickjump2: 'Product features',
        HzQuickjump3: 'Application scenarios',
        HzQuickjump4: 'Voice of the Customer',
        HzQuickjump5: 'Product Comparison',
        HzQuickjump6: 'Quick Start',
    },

    agent: {
        bannerTitle: 'Agent Recruitment Program Fully Launched',
        bannerSubtitle: 'Massive Resources · Easy Deployment · Worry-Free Agency · Win-Win Cooperation',
        bannerButton: 'Join Now',
        openProductAbility: 'Open Product Capabilities',
        product1Title: 'Cloud Server',
        product1Desc: 'High-performance cloud computing servers, providing a stable and reliable operating environment, supporting elastic scaling.',
        product2Title: 'Cloud Virtual Hosting',
        product2Desc: 'Cloud computing-based virtual hosting service, providing secure and stable website hosting solutions for you.',
        product3Title: 'Server Hosting',
        product3Desc: 'Professional server hosting services, providing a secure, stable, and high-performance hosting environment.',
        product4Title: 'Website Filing',
        product4Desc: 'Fast and convenient website filing service, with a professional team providing guidance throughout the process to ensure smooth passage.',
        product5Title: 'Domain Registration',
        product5Desc: 'Global domain registration service, supporting multiple extensions, with preferential prices and easy registration.',
        product6Title: 'Bare Metal Server',
        product6Desc: 'High-performance physical servers, providing dedicated resources to meet high-performance computing needs.',
        product7Title: 'CDN Acceleration',
        product7Desc: 'Global node distribution, intelligent acceleration, providing stable and fast content delivery services.',
        product8Title: 'More Services',
        product8Desc: 'Explore more cloud service products, providing comprehensive solutions for your business.',
        cooperationAdvantage: 'Cooperation Advantages',
        advantage1Title: 'Full-Channel IDC Resource Access',
        advantage1Desc: 'Supports mainstream network access such as multi-line BGP, telecom, Unicom, and mobile, providing diversified data center interfaces for elastic business deployment and efficient resource coordination.',
        advantage2Title: 'High-Profit Agency Commission',
        advantage2Desc: 'Based on the advantages of large-scale cloud service resources, we offer competitive agency policies and tiered profit sharing to help partners quickly increase revenue and market share.',
        advantage3Title: 'Zero Startup Cost Investment',
        advantage3Desc: 'No need to build your own data center or invest in hardware. Relying on our mature cloud infrastructure, we support pay-as-you-go and elastic scaling, helping businesses launch quickly and scale flexibly.',
        advantage4Title: 'Professional Technical Support',
        advantage4Desc: 'Providing 7x24 operational support, one-on-one technical consultation, and comprehensive pre-sales and after-sales services to ensure stable operation and sustainable development of partner businesses.',
        cooperationProcess: 'Cooperation Process',
        process1Title: 'Register Account',
        process1Desc: 'Quickly complete account registration to begin the intelligent cooperation journey.',
        process2Title: 'Service Authorization',
        process2Desc: 'Complete service authorization to ensure a safe and reliable cooperation environment.',
        process3Title: 'Purchase System',
        process3Desc: 'Choose the suitable system package and complete the purchase with one click.',
        process4Title: 'System Configuration',
        process4Desc: 'Professional team assists in completing personalized system configuration.',
        process5Title: 'Start Cooperation',
        process5Desc: 'Formally start the cooperation and enjoy an intelligent service experience.',
        cooperationSupport: 'Cooperation Support',
        support1Title: 'Free Agency Access',
        support1EnTitle: 'Free Agent Access',
        support1Desc: 'Quickly obtain agency qualifications for the full range of products including hosts, cloud servers, and data centers, enjoying exclusive channel benefits.',
        support2Title: 'Official Authorization Certification',
        support2EnTitle: 'Official Certification',
        support2Desc: 'Providing both electronic and paper certification to ensure cooperation compliance and the effectiveness of brand authorization.',
        support3Title: 'Exclusive Channel Pricing',
        support3EnTitle: 'Channel Exclusive Pricing',
        support3Desc: 'Based on agency level and performance, we offer tiered preferential policies to enhance your market quotation competitiveness.',
        support4Title: 'Dedicated Channel Manager',
        support4EnTitle: 'Dedicated Manager',
        support4Desc: 'One-on-one follow-up throughout the process, providing pre-sales consultation, solution customization, and business collaboration support.',
        support5Title: 'Exclusive Product Training',
        support5EnTitle: 'Product Training',
        support5Desc: 'Regularly organize product, technical, and sales training to help teams quickly master IDC and cloud service expertise.',
        support6Title: 'Advantageous Pricing System',
        support6EnTitle: 'Competitive Pricing',
        support6Desc: 'Leveraging a large-scale resource pool to provide advantageous channel prices, supporting you in flexibly formulating market strategies.',
        support7Title: '7x24 After-Sales Support',
        support7EnTitle: '24/7 Support',
        support7Desc: 'Providing round-the-clock ticket, online, and phone support to quickly respond to and resolve operational issues.',
        support8Title: 'VIP Technical Support',
        support8EnTitle: 'VIP Tech Support',
        support8Desc: 'Equipped with senior architects and operation experts to provide in-depth technical support for your important projects.',
        contactUs: 'Contact Us',
        cooperationCondition: 'Cooperation Conditions',
        condition1Title: 'Company Qualification',
        condition1Desc: 'Possesses formal corporate qualification certification, with a complete management system and professional technical team, ensuring stable and reliable cooperation.',
        condition2Title: 'Service Capability',
        condition2Desc: 'Equipped with a professional technical support team, providing 7x24 response services to ensure smooth business operations.',
        condition3Title: 'Business Capability',
        condition3Desc: 'Possesses rich customer resources and market expansion experience, with strong business execution and innovation capabilities.',
        condition4Title: 'Cooperation Intention',
        condition4Desc: 'Upholds an open and win-win philosophy, willing to establish long-term and stable strategic cooperative relationships with quality partners.',
        faqTitle: 'Frequently Asked Questions',
        faq1Question: 'How to start a cloud service agency cooperation?',
        faq1Step1: 'Register a MainCloud platform account and complete enterprise real-name verification.',
        faq1Step2: 'Submit an agency application, providing corporate qualifications and business plan.',
        faq1Step3: 'After approval, sign the cloud service agency cooperation agreement.',
        faq1Step4: 'Obtain agency permissions and management backend, and begin business promotion.',
        faq2Question: 'What are the requirements for cloud service agency qualification?',
        faq2Requirement1: 'Business License (must be valid).',
        faq2Requirement2: 'Legal Representative ID and Power of Attorney.',
        faq2Requirement3: 'IDC/ISP Operation License or relevant industry qualifications.',
        faq2Requirement4: 'Possesses a cloud service sales or technical team.',
        faq3Question: 'Which cloud service products can be represented?',
        faq3Product1: 'Elastic Cloud Server ECS',
        faq3Product2: 'Cloud Database RDS',
        faq3Product3: 'Cloud Security Protection (WAF/DDOS)',
        faq3Product4: 'Cloud Direct Connect / CDN / Load Balancer',
        faq3Product5: 'Object Storage / File Storage',
        faq3Product6: 'Hybrid Cloud / Private Cloud Solutions',
        faq3Product7: 'Container Service and Kubernetes',
        faq3Product8: 'Cabinet Rental / Server Hosting',
        faq4Question: 'What are the preferential policies for agency cooperation?',
        faq4Plan1Title: 'Standard Agent',
        faq4Plan1Desc: 'Enjoy 15% off products + basic commission.',
        faq4Plan2Title: 'Gold Agent',
        faq4Plan2Desc: 'Enjoy 25% off products + tiered commission.',
        faq4Plan3Title: 'Diamond Agent',
        faq4Plan3Desc: 'Enjoy 35% off products + exclusive commission.',
        faq4Plan4Title: 'Strategic Partner',
        faq4Plan4Desc: 'Customized preferential plan + dedicated support.',
        faq5Question: 'What does technical support and training include?',
        faq5Support1: '7x24 hour ticket and phone technical support.',
        faq5Support2: 'Regular cloud product technical training and certification.',
        faq5Support3: 'Pre-sales solution support and POC testing.',
        faq5Support4: 'Dedicated technical manager and architecture consulting.',
        faq6Question: 'What are the settlement and commission policies?',
        faq6Policy1Title: 'Settlement Cycle',
        faq6Policy1Desc: 'Monthly settlement, payment within T+15 working days.',
        faq6Policy2Title: 'Commission Method',
        faq6Policy2Desc: 'Tiered commission based on quarterly performance achievement.',
        faq6Policy3Title: 'Additional Incentives',
        faq6Policy3Desc: 'Additional bonuses for exceeding targets.',
        faq6Policy4Title: 'Market Support',
        faq6Policy4Desc: 'Funding support for joint marketing activities.'
    },

    consult: {
        modalTitle: 'Solution Consultation',
        formLabels: {
            contact: 'Contact Person',
            company: 'Company Name',
            phone: 'Phone Number',
            email: 'Email',
            matter: 'Consultation Product'
        },
        formPlaceholders: {
            contact: 'Please enter contact person',
            company: 'Please enter company name',
            phone: 'Please enter phone number',
            email: 'Please enter email',
            matter: 'Please enter the product information you want to consult'
        },
        formRules: {
            contactRequired: 'Please enter contact person',
            phoneOrEmailRequired: 'Please fill in phone or email',
            phonePattern: 'Please enter a valid phone number',
            emailType: 'Please enter a valid email format',
            matterRequired: 'Please enter consultation product'
        },
        formError: {
            contactRequired: 'Please enter contact person',
            phoneOrEmailRequired: 'Phone number and email must be filled in at least one',
            phoneInvalid: 'Please enter a valid phone number',
            emailInvalid: 'Please enter a valid email format',
            matterRequired: 'Please enter consultation product',
            submitFailed: 'Submission failed, please try again later',
            networkError: 'Network error, please try again later'
        }
    },

    company: {
        aboutUs: 'About Us',
        bannerSlogan: 'Love, Responsibility, Integrity, Win-Win, Cooperation, Innovation',
        quickJump: {
            companyProfile: 'Company Profile',
            corporateCulture: 'Corporate Culture',
            qualifications: 'Qualifications',
            honorRoad: 'Honor Road',
            feedback: 'Feedback'
        },
        companyProfile: {
            title: 'company',
            title2: 'briefIntroduction',
        },
        corporateCulture: {
            title: 'Corporate Culture',
            subtitle: 'corporateCulture',
            mission: {
                title: 'Mission',
                desc: 'Making Data Valuable'
            },
            vision: {
                title: 'Vision',
                desc: 'Enable Every Organization and Individual to See and Benefit from Digitalization'
            },
            values: {
                title: 'Values',
                desc: 'Customer First, Teamwork, Professionalism, Responsibility'
            }
        },
        qualifications: {
            title: 'Qualifications'
        },
        honorRoad: {
            title: 'Honor Road',
            subtitle: 'Honor'
        },
        feedback: {
            title: 'Feedback Information',
            titlePlaceholder: 'Title (Required*)',
            contactPlaceholder: 'Contact Information',
            descriptionLabel: 'Description:',
            descriptionPlaceholder: 'Please enter content (Required*)',
            submitButton: 'Submit Now',
            typeTitle: 'Your Feedback Type',
            required: '(Required)'
        }
    },

    cps: {
        bannerTitle: 'Invite Friends to the Cloud, Win 35% Cashback Rewards',
        bannerDesc: 'Individual users can become promotion ambassadors through real-name authentication, publish exclusive promotion links on social platforms or personal sites to acquire associated customers, and receive cashback rewards when associated customers place orders.',
        joinNow: 'Join Now',
        advantagesTitle: 'Promotion Advantages',
        advantagesSubtitle: 'We provide comprehensive promotion solutions to help your business grow rapidly',
        commissionTitle: 'Generous Commission Returns',
        commissionDesc: 'We offer industry-competitive commission rates for partners. Each successful promotion you make will receive corresponding commission rewards, allowing your promotion value to be tangibly realized.',
        conversionTitle: 'High Conversion Product Support',
        conversionDesc: 'Focuses on the IDC field, providing diverse products and solutions from cloud servers, physical servers to high defense, CDN, etc. The products have stable performance and outstanding cost-effectiveness, meeting the needs of enterprises of different scales, providing strong support for your promotion, and effectively improving user conversion and order efficiency.',
        coverageTitle: 'Wide Commission Coverage',
        coverageDesc: 'Our commission policy covers comprehensively. Whether it\'s a new user\'s first purchase, an existing user\'s renewal upgrade, or orders using promotional activities, as long as they are completed through your exclusive promotion link, commissions will be calculated for you, maximizing your promotion benefits.',
        settlementTitle: 'Flexible and Quick Settlement',
        settlementDesc: 'We are committed to providing partners with a smooth settlement experience. We support multiple mainstream withdrawal methods, with no minimum withdrawal threshold. The settlement process is clear and efficient, ensuring your promotion commissions reach your account promptly and securely.',
        joinTitle: 'Join Cloud Promotion Officer',
        joinSubtitle: 'Customers can receive cash rewards when they successfully use the promotion link shared by the promoter',
        step1Title: 'Register/Login as Member',
        step1Time: 'About 2 minutes',
        step1Desc: 'Quickly register to become a Cloud Promotion Officer member',
        step2Title: 'Upgrade to Distributor',
        step2Time: 'About 5 minutes',
        step2Desc: 'Complete real-name authentication to upgrade to distributor status',
        step3Title: 'Promote to Acquire Customers',
        step3Time: 'About 10 minutes',
        step3Desc: 'Share promotion links to acquire customers',
        step4Title: 'Enjoy Double Commissions',
        step4Time: 'About 1-7 working days',
        step4Desc: 'Get rewards upon successful promotion',
        methodsTitle: 'Promotion Methods',
        methodsSubtitle: 'Customers can receive cash rewards when they successfully use the promotion link shared by the promoter',
        method1Title: 'Precision Advertising Promotion',
        method1Desc: 'Accurately target users through intelligent algorithms, providing personalized advertising services. Supports independent selection of advertising positions on multiple platforms, real-time data monitoring, and optimization of promotion effects. Combined with a complete data analysis system, every investment creates maximum value.',
        method1Feature1: 'Precision User Profile Analysis',
        method1Feature2: 'Multi-platform Advertising Placement',
        method1Feature3: 'Real-time Effect Monitoring',
        method2Title: 'Community Matrix Promotion',
        method2Desc: 'Build a high-quality community ecosystem and establish loyal user groups through refined operations. Provide professional community management tools to help enterprises establish a complete community operation system, achieving precise user reach and conversion.',
        method2Feature1: 'Community Operation System Construction',
        method2Feature2: 'Activity Planning and Execution',
        method2Feature3: 'User Interaction Management',
        method3Title: 'Content Marketing Promotion',
        method3Desc: 'Professional content creation team, creating high-quality brand content for you. Covers various forms such as articles, videos, graphics, establishing brand influence through quality content, and improving user conversion rates.',
        method3Feature1: 'Professional Content Creation',
        method3Feature2: 'Multi-platform Content Distribution',
        method3Feature3: 'Effect Data Analysis',
        startPromotion: 'Start Promoting Now',
        distributorTitle: 'Distributor Advantages',
        distributorSubtitle: 'Customers can receive cash rewards when they successfully use the promotion link shared by the promoter',
        comparisonItem: 'Comparison Item',
        otherVendors: 'Other Cloud Vendors',
        commissionAmount: 'Commission Amount',
        otherCommissionAmount: 'About 15% (excluding tax, high tax fees need to be deducted during settlement)',
        ourCommissionAmount: 'Pure 18% Profit',
        settlementCycle: 'Settlement Cycle',
        otherSettlementCycle: 'Settle last month\'s commissions in the second half of each month',
        ourSettlementCycle: 'Can withdraw 5 days after order confirmation',
        promotionScope: 'Promotion Scope',
        otherPromotionScope: 'Only personal user promotion',
        ourPromotionScope: 'Individuals, enterprises, and teams can participate',
        orderValidity: 'Order Validity',
        otherOrderValidity: 'Discount orders do not count commissions',
        ourOrderValidity: 'Discount orders also calculate commissions',
        technicalSupport: 'Technical Support',
        otherTechnicalSupport: 'Need to queue for customer service response',
        ourTechnicalSupport: 'Dedicated technical consultant 1-on-1 support',
        commissionTiers: 'Commission Tiers',
        otherCommissionTiers: 'Fixed ratio, no growth mechanism',
        ourCommissionTiers: 'Higher commission ratio with more promotion volume',
        settlementMethods: 'Settlement Methods',
        otherSettlementMethods: 'Only corporate account settlement',
        ourSettlementMethods: 'Support Alipay, WeChat, corporate accounts',
        promotionMaterials: 'Promotion Materials',
        otherPromotionMaterials: 'Basic materials, need to design yourself',
        ourPromotionMaterials: 'Provide complete set of marketing materials and copywriting',
        dataReports: 'Data Reports',
        otherDataReports: 'Data synchronization once a month',
        ourDataReports: 'Real-time data dashboard, view anytime',
        customerOwnership: 'Customer Ownership',
        otherCustomerOwnership: 'Commission terminates after customer churn',
        ourCustomerOwnership: 'Customers are long-term bound, continuous income',
        rulesTitle: 'Distributor Rules',
        rulesSubtitle: 'Customers can receive cash rewards when they successfully use the promotion link shared by the promoter',
        commissionRulesTitle: 'Commission Rules',
        firstSaleCommission: 'First sale commission = Valid sales revenue × 13%',
        renewalCommission: 'Renewal commission = Valid renewal revenue × 5%',
        qualificationTitle: 'Distributor Qualification',
        qualificationDesc: 'Both new and existing users can register as cloud service promotion distributors, enjoying promotion rights for all product series',
        validSalesTitle: 'Valid Sales Revenue',
        validSalesRule1: 'Specified promotion products are cloud servers and cloud virtual hosts paid annually',
        validSalesRule2: 'The first order registered, purchased, and paid by the promoted user through the promotion link, the cash portion paid belongs to valid sales revenue',
        validSalesRule3: 'The cash portion paid by the promoted user using coupons to complete new server and virtual host purchase orders belongs to valid sales revenue',
        validSalesRule4: '"Valid sales revenue" generated from cloud server and virtual host renewals and upgrades, specific commission ratio is subject to product commission rules',
        validSalesRule5: 'Refunds caused by user returns will be deducted from valid sales revenue',
        settlementTitle: 'Settlement',
        settlementRule1: 'Promoters are settled by the system within 15 days after order creation',
        settlementRule2: 'Settlement rules and settlement data are based on system statistics',
        prohibitedTitle: 'Prohibited Terms',
        prohibitedDesc: 'Prohibited from using malicious code to forcibly change user computer settings; prohibited from using malicious methods such as forced bundling, or other inappropriate methods that users dislike or violate laws and regulations for promotion.'
    },

    doc: {
        bannerTitle: 'Documentation Center',
        bannerDesc: 'Integrate common usage questions and development documentation for the full range of products, providing you with convenient and fast self-service guidance to help you quickly master the cloud.',
        searchPlaceholder: 'Please enter keywords to search documents...',
        searchButton: 'Search',
        contentTitle: 'Document Content'
    },

    ecommerce: {
        bannerTitle: 'E-commerce Cloud Solution',
        bannerDesc: 'We have launched a full stack e-commerce cloud solution, which is deeply optimized to cope with massive transactions, sudden traffic, and rapid business iteration.',
        freeConsultation: 'Free Consultation',
        advantagesTitle: 'Solution Advantages',
        advantagesSubtitle: 'Provide comprehensive website solutions for your enterprise',
        advantage1Title: 'Global Acceleration Network Assurance',
        advantage1Desc: 'Deploy high-speed network nodes covering the globe, intelligently optimize transmission paths, ensuring players can obtain low-latency, highly stable, and smooth access experiences from any location worldwide.',
        advantage2Title: 'Multi-layer Security Protection',
        advantage2Desc: 'Build a deep defense security system from the network layer, application layer to the data layer, effectively defending against DDoS attacks, vulnerability intrusions, and data breaches, comprehensively protecting business and user information security.',
        advantage3Title: 'Intelligent Elastic Scaling Solution',
        advantage3Desc: 'Based on real-time monitoring of business load, achieve automated elastic scaling of computing and storage resources, calmly handle traffic peaks and daily fluctuations, optimizing resource utilization and cost efficiency.',
        advantage4Title: '24/7 Professional Support',
        advantage4Desc: 'Provide round-the-clock technical expert support and operation maintenance, quickly respond to and resolve various technical failures, ensure business continuity, and safeguard your stable operation.',
        architectureTitle: 'Solution Architecture',
        architectureSubtitle: 'Adopting advanced technical architecture to provide reliable website services for you',
        architectureDescTitle: 'Architecture Description',
        architectureDesc: 'Our e-commerce solution adopts a distributed architecture design, achieving omnichannel business operations through multi-level service node deployment. The system includes:',
        architectureFeature1: 'Omnichannel Product Management System',
        architectureFeature2: 'Intelligent Order Processing Center',
        architectureFeature3: 'Payment Security and Risk Control System',
        architectureFeature4: 'Data Analysis and Operation Platform',
        learnMore: 'Learn More',
        painPointsTitle: 'Industry Pain Points',
        painPointsSubtitle: 'Facing rapid industry iteration and fierce competition, traditional technical architectures and operation models have become invisible ceilings restricting product innovation and growth.',
        painPoint1Title: 'Business Agility Challenges',
        painPoint1Desc: 'Frequent e-commerce promotions and hotspot activities require minute-level computing resource deployment and elastic scaling to support instantaneous high-concurrency orders and traffic surges',
        painPoint2Title: 'Upgraded Security Threats',
        painPoint2Desc: 'Security threats such as DDoS attacks, malicious order brushing, payment fraud, and data crawling continue to emerge, seriously threatening e-commerce business and user asset security',
        painPoint3Title: 'Data Governance Difficulties',
        painPoint3Desc: 'The management, integration, analysis, and application of massive multi-source data such as orders, users, products, and logs are complex, making data-driven decision-making difficult and costly',
        painPoint4Title: 'System Recovery Challenges',
        painPoint4Desc: 'Need to support lossless, rapid recovery of core transaction data, orders, and inventory; traditional backup and rollback mechanisms are difficult to meet e-commerce high availability requirements'
    },

    finance: {
        bannerTitle: 'Financial Cloud Solution',
        bannerDesc: 'Providing secure, compliant financial cloud solutions for digital transformation in banking, securities, insurance, and internet finance industries.',
        freeConsultation: 'Free Consultation',
        advantagesTitle: 'Solution Advantages',
        advantagesSubtitle: 'Providing comprehensive website solutions for your enterprise',
        advantage1Title: 'Financial-Grade Performance',
        advantage1Desc: 'High-availability, low-latency cloud architecture supporting millisecond response for high-frequency trading',
        advantage2Title: 'Compliance Security',
        advantage2Desc: 'Comprehensive security system meeting Level 3 compliance and financial regulations',
        advantage3Title: 'Intelligent Scaling',
        advantage3Desc: 'Smart elastic scaling based on business load, auto-scaling during peak trading periods',
        advantage4Title: 'Dedicated Support',
        advantage4Desc: '24/7 financial-specialized technical support with extensive industry experience',
        architectureTitle: 'Solution Architecture',
        architectureSubtitle: 'Advanced technical architecture for reliable website services',
        architectureDescTitle: 'Architecture Description',
        architectureDesc: 'Our financial solution uses distributed architecture with multi-level service deployment',
        architectureFeature1: 'Omnichannel Trading System',
        architectureFeature2: 'Intelligent Risk Control',
        architectureFeature3: 'Payment Security Monitoring',
        architectureFeature4: 'Data Analysis Platform',
        learnMore: 'Learn More',
        painPointsTitle: 'Industry Pain Points',
        painPointsSubtitle: 'Traditional architectures limit innovation and growth in competitive financial sector',
        painPoint1Title: 'Business Agility',
        painPoint1Desc: 'Slow traditional system iteration, difficult to support agile development and scaling',
        painPoint2Title: 'Compliance Security',
        painPoint2Desc: 'Strict regulations, multiple security challenges including data protection and fraud prevention',
        painPoint3Title: 'Data Management',
        painPoint3Desc: 'Technical bottlenecks in collecting, analyzing multi-source financial data',
        painPoint4Title: 'Disaster Recovery',
        painPoint4Desc: 'High costs, long recovery times with traditional backup solutions'
    },

    game: {
        bannerTitle: 'Game Cloud Solution',
        bannerDesc: 'Empowering game developers with comprehensive cloud solutions for better performance and player experience.',
        freeConsultation: 'Free Consultation',
        advantagesTitle: 'Solution Advantages',
        advantagesSubtitle: 'Providing comprehensive website solutions for your enterprise',
        advantage1Title: 'Smart Game Updates',
        advantage1Desc: 'Fast, precise game patch and resource distribution with global CDN and P2P technology',
        advantage2Title: 'Virtual Goods Management',
        advantage2Desc: 'High-availability virtual goods and activation code management with security controls',
        advantage3Title: 'Massive Log Storage',
        advantage3Desc: 'PB-level real-time log platform for game behavior, performance, and business analytics',
        advantage4Title: 'Cross-region Network',
        advantage4Desc: 'Global dedicated network reducing latency and packet loss for online gaming',
        architectureTitle: 'Solution Architecture',
        architectureSubtitle: 'Advanced technical architecture for reliable website services',
        architectureDescTitle: 'Architecture Description',
        architectureDesc: 'Microservices architecture for high-availability, high-performance gaming services',
        architectureFeature1: 'Multi-region deployment',
        architectureFeature2: 'Auto-scaling, cost optimized',
        architectureFeature3: 'Real-time monitoring',
        architectureFeature4: 'Security protection',
        learnMore: 'Learn More',
        painPointsTitle: 'Industry Pain Points',
        painPointsSubtitle: 'Traditional architectures limit innovation and growth in competitive gaming industry',
        painPoint1Title: 'Agility Challenges',
        painPoint1Desc: 'Rapid changes require minute-level server deployment and scaling',
        painPoint2Title: 'Security Threats',
        painPoint2Desc: 'Frequent DDoS attacks, cheating, and new vulnerabilities threaten game stability',
        painPoint3Title: 'Operation Complexity',
        painPoint3Desc: 'Complex management of massive game logs and monitoring systems',
        painPoint4Title: 'Data Recovery',
        painPoint4Desc: 'Need for quick, precise data restoration, challenging with traditional backups'
    },

    service: {
        bannerTitle: 'Premium Service, Cloud with Confidence',
        bannerDesc: 'Complete VIP service system providing comprehensive support for domestic and international users',
        quickJump: {
            basicService: 'Basic Service',
            filing: 'Free Filing',
            compensation: '100x Fault Compensation',
            refund: '1-Day Refund'
        },
        basicServiceTitle: 'Basic Service',
        basicServiceSubtitle: '7x24 support channels for easy cloud migration',
        support24x7Title: '24/7 Service Support',
        support24x7Desc: 'Professional engineers providing round-the-clock technical support',
        preSales: 'Pre-Sales',
        preSalesDesc: 'Customized product consultation and solution recommendations',
        preSalesConsult: 'Pre-Sales',
        duringSales: 'During Sales',
        duringSalesDesc: 'One-on-one technical guidance for system deployment',
        duringSalesConsult: 'During Sales',
        afterSales: 'After-Sales',
        afterSalesDesc: 'Technical support and system optimization services',
        afterSalesConsult: 'After-Sales',
        technicalTicket: 'Technical Ticket',
        technicalTicketDesc: '24/7 online ticket support',
        submitTicket: 'Submit Ticket',
        vipServiceTitle: 'VIP Multi-to-One Service',
        vipServiceDesc: 'Professional, efficient one-stop solutions',
        wechatGroup: 'WeChat Group',
        wechatGroupDesc: 'Join VIP WeChat group for direct expert support',
        qqContact: 'QQ Contact',
        qqContactDesc: 'Contact customer service anytime via QQ',
        consultationHotline: 'Hotline',
        consultationHotlineDesc: 'Call our hotline for immediate consultation',
        filingTitle: 'Free Website Filing',
        filingSubtitle: 'Free filing service, 1V1 processing, fastest 1 working day approval',
        filingStep1: 'Login Member Center',
        filingStep2: 'Submit Information',
        filingStep3: 'Authority Review',
        filingStep4: 'Filing Approved',
        filingButton: 'File Now',
        faqTitle: 'Filing FAQ',
        faq1Question: 'How long does filing take?',
        faq1Answer: 'Initial review 1-2 days, authority review typically 1-2 weeks, maximum 20 working days.',
        faq2Question: 'Close website during filing?',
        faq2Answer: 'New filings require website closure during review. Existing filings can remain open.',
        faq3Question: 'How to add whitelist?',
        faq3Answer: 'Submit domain and filing number in member center. Instant approval for filed domains.',
        faq4Question: 'Photo requirements?',
        faq4Answer: 'Upper body photo centered against backdrop, clear background required.',
        compensationTitle: '100x Fault Compensation',
        compensationSubtitle: '100x downtime compensation for network fault issues',
        compensationStep1: 'Contact Support',
        compensationStep2: 'Technical Diagnosis',
        compensationStep3: 'Resolve Fault',
        compensationStep4: 'Verify Scope',
        compensationStep5: '100x Compensation',
        compensationTypes: 'Compensation Types',
        compensationType1: 'Fault Compensation',
        compensationType1Desc: 'For network platform failures affecting server accessibility',
        compensationType2: 'Non-compensable',
        compensationType2Desc: 'User operation or attack-related issues not compensated',
        compensationType3: 'ISP Fault',
        compensationType3Desc: 'ISP network issues, force majeure excluded',
        refundTitle: '1-Day Refund',
        refundSubtitle: 'Unconditional 1-day refund for cloud servers, better service experience',
        refundStep1: 'Submit Request',
        refundStep1Desc: 'Submit refund request via customer platform',
        refundStep2: 'Review',
        refundStep2Desc: 'Quick review by customer service team',
        refundStep3: 'Refund to Balance',
        refundStep3Desc: 'Refund to account balance after approval',
        refundStep4: 'Repurchase',
        refundStep4Desc: 'Use balance for new purchase or withdraw',
        refundFaqTitle: 'Refund FAQ',
        refundFaq1Question: 'Refund Conditions',
        refundFaq1Answer: 'New purchases within 1 day. Limit 1 server/1 host per user monthly. Excludes contracts/invoices.',
        refundFaq2Question: 'Refund Process',
        refundFaq2Answer: 'Submit request > System review > Refund to account balance',
        refundFaq3Question: 'Renewal/Upgrade refund?',
        refundFaq3Answer: 'Renewal/upgrade orders not refundable. Main orders eligible for 1-day refund.'
    },

    mobile: {
        bannerTitle: 'Mobile Cloud Solution',
        bannerDesc: 'End-to-end mobile cloud solutions for fast-growing mobile business and digital transformation needs.',
        freeConsultation: 'Free Consultation',
        advantagesTitle: 'Solution Advantages',
        advantagesSubtitle: 'Providing comprehensive website solutions for your enterprise',
        advantage1Title: 'Mobile-first Architecture',
        advantage1Desc: 'Mobile-optimized cloud architecture supporting massive concurrent connections for smooth app experience',
        advantage2Title: 'End-to-end Security',
        advantage2Desc: 'Comprehensive security covering mobile devices, network, and cloud services',
        advantage3Title: 'Edge Computing',
        advantage3Desc: 'Edge and cloud synergy reducing latency and improving mobile app performance',
        advantage4Title: 'Mobile Specialized Support',
        advantage4Desc: 'Expert mobile technology team providing 24/7 architecture and performance support',
        architectureTitle: 'Solution Architecture',
        architectureSubtitle: 'Advanced technical architecture for reliable website services',
        architectureDescTitle: 'Architecture Description',
        architectureDesc: 'Distributed architecture with multi-level service nodes for global business coverage',
        architectureFeature1: 'Edge Node Scheduling',
        architectureFeature2: 'Global Load Balancing',
        architectureFeature3: 'Real-time Monitoring',
        architectureFeature4: 'Intelligent Operations',
        learnMore: 'Learn More',
        painPointsTitle: 'Industry Pain Points',
        painPointsSubtitle: 'Traditional architectures limit innovation and growth in competitive mobile industry',
        painPoint1Title: 'Resource Efficiency',
        painPoint1Desc: 'Dynamic mobile traffic patterns challenge traditional static resource allocation',
        painPoint2Title: 'Security Risks',
        painPoint2Desc: 'Complex mobile environments face multiple security threats across devices, networks, and cloud',
        painPoint3Title: 'Cross-network Experience',
        painPoint3Desc: 'Network variations make consistent quality experience difficult across all users',
        painPoint4Title: 'Operations Complexity',
        painPoint4Desc: 'Complex multi-layer architecture makes troubleshooting and management challenging'
    },

    news: {
        bannerTitleNews: 'News Center',
        bannerTitleAnnouncement: 'Announcement Center',
        bannerDesc: 'Real-time updates on computing services to help you better understand and use our products.',
        loading: 'Loading...',
        newsCenter: 'News Center',
        announcementCenter: 'Announcement Center',
        newsDetails: 'News Details',
        totalData: 'Total',
        records: 'records',
        newsAnnouncement: 'News & Announcements'
    },

    newsDetail: {
        home: 'Home',
        announcementHome: 'Announcements',
        keywords: 'Keywords: ',
        noKeywords: 'No keywords',
        source: 'Source: ',
        publishTime: 'Published: ',
        shareLink: 'Share Link',
        shareLinkAlt: 'Share Link',
        shareWeChat: 'Share to WeChat',
        shareWeChatAlt: 'Share to WeChat',
        shareQQ: 'Share to QQ',
        shareQQAlt: 'Share to QQ',
        previous: 'Previous: ',
        next: 'Next: ',
        newsAnnouncement: 'News & Announcements'
    },

    product: {
        console: 'Console',
        suitableRegion: 'Suitable Region',
        quickJump: {
            advantages: 'Advantages',
            features: 'Features',
            applicationScenarios: 'Use Cases',
            customerVoice: 'Testimonials',
            productComparison: 'Comparison',
            quickStart: 'Quick Start'
        },
        advantages: 'Advantages',
        features: 'Features',
        applicationScenarios: 'Use Cases',
        customerVoice: 'Testimonials',
        productComparison: 'Product Comparison',
        comparisonSubtitle: 'Customers receive cash rewards through successful promotion links',
        comparisonItem: 'Comparison',
        otherVendors: 'Other Vendors',
        quickStart: 'Quick Start'
    },

    website: {
        bannerTitle: 'Website Solution',
        bannerDesc: 'Enterprise-grade security with WAF, DDoS protection, IDS, and penetration testing',
        freeConsultation: 'Free Consultation',
        advantagesTitle: 'Solution Advantages',
        advantagesSubtitle: 'Providing comprehensive website solutions for your enterprise',
        advantage1Title: 'High-performance Architecture',
        advantage1Desc: 'Scalable microservices architecture supporting high concurrency and intelligent load balancing',
        advantage2Title: 'Comprehensive Security',
        advantage2Desc: 'Multi-layer security including WAF, DDoS protection, intrusion detection, and encryption',
        advantage3Title: 'Intelligent Operations',
        advantage3Desc: '24/7 monitoring with global CDN, self-healing faults, and fast response',
        advantage4Title: 'Full Lifecycle Service',
        advantage4Desc: 'End-to-end service from planning to operation, seamless integration with existing systems',
        architectureTitle: 'Solution Architecture',
        architectureSubtitle: 'Advanced technical architecture for reliable website services',
        architectureDescTitle: 'Architecture Description',
        architectureDesc: 'Multi-layer architecture for highly available, high-performance website services:',
        architectureFeature1: 'Load balancing for optimal request distribution and performance',
        architectureFeature2: 'Containerized application services for easy scaling and maintenance',
        architectureFeature3: 'Master-slave database architecture ensuring data security and availability',
        architectureFeature4: 'Real-time monitoring system for quick response to issues',
        learnMore: 'Learn More',
        painPointsTitle: 'Industry Pain Points',
        painPointsSubtitle: 'Traditional architectures limit innovation and growth in competitive market',
        painPoint1Title: 'Resource Efficiency',
        painPoint1Desc: 'Traditional static resource allocation fails to handle traffic peaks',
        painPoint2Title: 'Security Risks',
        painPoint2Desc: 'Multiple security threats require end-to-end protection',
        painPoint3Title: 'Network Experience',
        painPoint3Desc: 'Network variations make consistent quality experience difficult',
        painPoint4Title: 'Operations Complexity',
        painPoint4Desc: 'Complex multi-layer architecture challenging for troubleshooting and management'
    },
}